// extracted by mini-css-extract-plugin
module.exports = {"modal_root":"AppInfo_modal_root__30WL0","container":"AppInfo_container__1qwLT","btn_action":"AppInfo_btn_action__1FLS8"};